import React from 'react';
import { connect } from 'react-redux';
import '../../../assets/styles/components/cash-account.scss';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP, settingConfigs } from '@/configurations';
import { Converter } from '@/helpers/functions';
import { getCashAccount, getPortfolioAction } from '@/actions/trading';
import { getSafe } from '@/helpers/global';
import { colorBindingTypes as colorTypes } from '@/constants/color-binding-type';
import { openAssetsDetails } from '@/actions/app'
import RefreshIcon from '@/assets/images/icons/icon_refresh.png';
import { Icons } from '@/configurations';
import classnames from 'classnames';

class CashAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cashAccountData: {},
      portfolioData: {},
      isLoading: false,
      openDetail : false
    }
  }

  render() {
    const { language , cashAccountData } = this.props;
    const { portfolioData, isLoading ,openDetail } = this.state;
    return (  
      <React.Fragment>
        <div className="cash-account-container">
        {/* {isLoading && <Icons.Loading />} */}
          <div className="grids-top-bar">
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_net_assets)} ({cashAccountData.ccy||'-'})</div>
                <div className="item-value">{cashAccountData.value}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_today_PL)}</div>
                <div className="item-value"
                  style={Converter.colorMapping(
                    colorTypes.UP_DOWN,
                    getSafe(() => portfolioData.floatingPL.replaceAll(settingConfigs.PRICE.thousandSeparator, ''), 0)
                  )}>
                  <span>{cashAccountData.todayDelayedProfitAndLoss}</span>
                  <span> ({portfolioData.floatingPLPercent ?
                    (Number(portfolioData.floatingPLPercent) > 0 ? `+${portfolioData.floatingPLPercent}` : (Number(portfolioData.floatingPLPercent) === 0 ? `${portfolioData.floatingPLPercent}` : `${portfolioData.floatingPLPercent}`)) :
                    `-`})</span>
                </div>
              </div>
            </div>
            {(isLoading) &&  <Icons.Loading />}
              {(!isLoading) && <div className= 'details-btn' onClick={this.handleOpenAssetsDetails}>
                <span>{getSafe(() => language.common_details)}</span>
              </div>}
          </div>
          <div className='buying-power'>
              <span>{getSafe(() => language.common_buying_power)}</span>
              <span>{cashAccountData.buyingPower}</span>
          </div>
          {<div className="details-items" style={{height:openDetail? '116px' :'0'}}>
            <div className='drawable-item'>
                <span>{getSafe(() => language.current_account_withdrawable)}</span>
                <span>{cashAccountData.withdrawableBal}</span>
            </div>
            <div className="detail-item-flex">
                  <div className="item-flex">
                    <div className="item-label">{getSafe(() => language.common_market_value)}</div>
                    <div className="item-value">{Converter.numericalTransformation(cashAccountData.marketValue,language)}</div>
                  </div>
                  <div className="item-flex">
                    <div className="item-label">{getSafe(() => language.current_account_pending)}</div>
                    <div className="item-value">{Converter.numericalTransformation(cashAccountData.pendingBal,language)}</div>
                  </div>
                  <div className="item-flex">
                    <div className="item-label">{getSafe(() => language.current_account_hold_amount)}</div>
                    <div className="item-value">{Converter.numericalTransformation(cashAccountData.holdAmount,language)}</div>
                  </div>
                  <div className="item-flex">
                    <div className="item-label">{getSafe(() => language.current_account_settled)}</div>
                    <div className="item-value">{Converter.numericalTransformation(cashAccountData.settledBalance,language)}</div>
                  </div>
                  <div className="item-flex">
                    <div className="item-label">{getSafe(() => language.current_account_margin_Value)}</div>
                    <div className="item-value">{Converter.numericalTransformation(cashAccountData.marginValue,language)}</div>
                  </div>
                  <div className="item-flex">
                    <div className="item-label">{getSafe(() => language.current_account_ledger)}</div>
                    <div className="item-value">{Converter.numericalTransformation(cashAccountData.ledgerBal,language)}</div>
                  </div>
            </div>
          </div>}
        </div>
      </React.Fragment>
    )
  }

  // getCashAccount = () => {
  //   const { currentTradingAccount, language } = this.props;
  //   const { clientID, tradingAccSeq } = currentTradingAccount
  //   const params = {
  //     [PARAMS.CLIENT_ID]: clientID,
  //     [PARAMS.TRADING_ACCOUNT_ID]: clientID,
  //     [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
  //     [PARAMS.LANGUAGE]: language.lang
  //   }
  //   this.setState({ isLoading: true })
  //   if (clientID) {
  //     this.props.getCashAccount(params, res => {
  //       if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
  //         this.setState({
  //           isLoading: false,
  //           cashAccountData: Converter.mapAssetAllocation(res)
  //         })
  //       }
  //     })
  //   } else {
  //     this.setState({
  //       isLoading: false,
  //       cashAccountData: Converter.mapAssetAllocation({})
  //     })
  //   }
  // }

  handleOpenAssetsDetails = (order) => {
    // openAssetsDetails(order);
    this.setState({openDetail:!this.state.openDetail})
  }

  getPortfolio = () => {
    const { currentTradingAccount, language } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    const params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getPortfolio(params, res => {
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          portfolioData: Converter.mapAccountPL(res)
        })
      }
    })
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount ,assetloading} = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      if(JSON.stringify(prevProps.currentTradingAccount) !== "{}"){
        // this.setState({isLoading:true})
        // this.props.getCashAccount(()=>{
        //   this.setState({isLoading:false})
        // })
      }
    }
    if (this.props.token && this.props.token !== prevProps.token) {
      // this.getCashAccount();
    }
    if (this.props.clientID !== prevProps.clientID) {
      // this.getCashAccount();
    }
    if(assetloading !==  prevProps.assetloading){
      this.setState({isLoading : assetloading})
    }
    // if (this.props.portfolios !== prevProps.portfolios) {
    //   this.setState({
    //     portfolioData: Converter.mapAccountPL(this.props.portfolios)
    //   })
    // }
  }

  componentDidMount() {
    const { currentTradingAccount, token } = this.props;
    if (token && currentTradingAccount) {
      // this.getCashAccount();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID,
    portfolios: state.trade.portfolios,
    token: state.auth.token,
    cashAccountData : state.trade.cashAccountData,
    assetloading : state.trade.assetloading
  }),
  dispatch => ({
    getCashAccount: (p, res) => dispatch(getCashAccount(p, res)),
    getPortfolio: (p, res) => dispatch(getPortfolioAction(p, res)),
  })
)(CashAccount)
